import axios from 'axios';

const External = {};
External.signup = async (user) => axios.post(`${process.env.VUE_APP_API}/1/user`, user);
External.signin = async (email, password) => axios.post(`${process.env.VUE_APP_API}/1/user/signin`, {email, password});
External.activate = async (token) => axios.get(`${process.env.VUE_APP_API}/1/user/activate/${token}`);
External.getInvitedUser = async (token) => (await axios.get(`${process.env.VUE_APP_API}/1/user/invitation/${token}`)).data;
External.invitationSignup = async (user) => (await axios.post(`${process.env.VUE_APP_API}/1/user/invitationsignup`, user)).data;
External.resend = async (email) => axios.post(`${process.env.VUE_APP_API}/1/user/resend`, {email});
External.request = async (email) => axios.post(`${process.env.VUE_APP_API}/1/user/request-reset`, {email});
External.reset = async (token, password) => axios.post(`${process.env.VUE_APP_API}/1/user/reset-password`, {token, password});
export default External;
